import asyncThunk from '@/lib/asyncThunk'

type Request = Record<never, never>

export const deleteCustomerLookup = asyncThunk<Request, void>({
  name: 'customer-lookup/delete',
  method: 'DELETE',
  uri: '/customer-lookup',
})
